const DOT_COLORS = ["#FF4D00", "#34D399", "#FBBF24", "#F472B6", "#38BDF8", "#A78BFA"];

// Visualização anonimizada: pontos ilustrativos (posição aproximada), nunca a localização exata.
function ring(count, radius, cx, cy, startIdx) {
  const n = Math.min(count, 5);
  const dots = [];
  for (let i = 0; i < n; i++) {
    const ang = (Math.PI * 2 * ((i + 0.5) / Math.max(n, 1))) + startIdx * 0.7;
    const r = radius * (0.68 + ((i % 2) * 0.22));
    dots.push({ x: cx + Math.cos(ang) * r, y: cy + Math.sin(ang) * r, c: DOT_COLORS[(startIdx + i) % DOT_COLORS.length] });
  }
  return dots;
}

export default function PlantaoRadar({ b5 = 0, b10 = 0, b20 = 0 }) {
  const cx = 90, cy = 90;
  const dots = [...ring(b5, 26, cx, cy, 0), ...ring(b10, 52, cx, cy, 2), ...ring(b20, 78, cx, cy, 4)];
  return (
    <div className="flex flex-col items-center" data-testid="plantao-radar">
      <svg viewBox="0 0 180 180" className="w-[180px] h-[180px]">
        <defs>
          <radialGradient id="radar-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="rgba(255,77,0,0.22)" />
            <stop offset="100%" stopColor="rgba(255,77,0,0)" />
          </radialGradient>
        </defs>
        <circle cx={cx} cy={cy} r="84" fill="url(#radar-glow)" />
        {[26, 52, 78].map((r) => (
          <circle key={r} cx={cx} cy={cy} r={r} fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
        ))}
        <line x1={cx} y1="8" x2={cx} y2="172" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        <line x1="8" y1={cy} x2="172" y2={cy} stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        <circle cx={cx} cy={cy} r="4" fill="#FF4D00" />
        <circle cx={cx} cy={cy} r="9" fill="none" stroke="#FF4D00" strokeOpacity="0.5" strokeWidth="1">
          <animate attributeName="r" from="4" to="30" dur="2.4s" repeatCount="indefinite" />
          <animate attributeName="stroke-opacity" from="0.5" to="0" dur="2.4s" repeatCount="indefinite" />
        </circle>
        {dots.map((d, i) => (
          <circle key={i} cx={d.x} cy={d.y} r="4.5" fill={d.c} stroke="#09090B" strokeWidth="1.5" data-testid={`radar-dot-${i}`} />
        ))}
      </svg>
      <span className="text-[10px] text-muted-foreground mt-1">Posição aproximada</span>
    </div>
  );
}
